// src/i18n.ts (i18next v22 + namespaces)
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { Capacitor } from "@capacitor/core";
import { Device } from "@capacitor/device";

// FR
import fr_common from "./locales/fr/common.json";
import fr_dashboard from "./locales/fr/dashboard.json";
import fr_myteam from "./locales/fr/myteam.json";
import fr_editteam from "./locales/fr/editteam.json";
import fr_addplayer from "./locales/fr/addplayer.json";
import fr_teamstats from "./locales/fr/teamstats.json";
import fr_seasonstats from "./locales/fr/seasonstats.json";
import fr_createteam from "./locales/fr/createteam.json";
import fr_legal from "./locales/fr/legal.json";
import fr_terms from "./locales/fr/terms.json";
import fr_footer from "./locales/fr/footer.json";
import fr_home from "./locales/fr/home.json";
import fr_contact from "./locales/fr/contact.json";
import fr_glossary from "./locales/fr/glossary.json";
import fr_features from "./locales/fr/features.json";
import fr_pricing from "./locales/fr/pricing.json";
import fr_profile from "./locales/fr/profile.json";
import fr_editprofile from "./locales/fr/editprofile.json";
import fr_playerpage from "./locales/fr/playerpage.json";
import fr_allmatches from "./locales/fr/allmatches.json";
import fr_matchdetails from "./locales/fr/matchdetails.json";
import fr_news from "./locales/fr/news.json";
import fr_login from "./locales/fr/login.json";
import fr_upgrade from "./locales/fr/upgrade.json";
import fr_signup from "./locales/fr/signup.json";
import fr_matchstats from "./locales/fr/matchstats.json";
import fr_editstats from "./locales/fr/editstats.json";
import fr_editmatch from "./locales/fr/editmatch.json";
import fr_trainingdetails from "./locales/fr/trainingdetails.json";
import fr_allplays from "./locales/fr/allplays.json";
import fr_alltrainings from "./locales/fr/alltrainings.json";
import fr_creatematch from "./locales/fr/creatematch.json";
import fr_resetpassword from "./locales/fr/resetpassword.json";
import fr_editplayer from "./locales/fr/editplayer.json";
import fr_plandetails from "./locales/fr/plandetails.json";
import fr_playbooks from "./locales/fr/playbooks.json";
import fr_playbookdetails from "./locales/fr/playbookdetails.json";
import fr_playbookeditor from "./locales/fr/playbookeditor.json";
import fr_resources from "./locales/fr/resources.json";
import fr_profilepublic from "./locales/fr/profilepublic.json";
import fr_teamplayers from "./locales/fr/teamplayers.json";
import fr_communityplays from "./locales/fr/communityplays.json";
import fr_editplay from "./locales/fr/editplay.json";
import fr_sharedplay from "./locales/fr/sharedplay.json";
import fr_createTraining from "./locales/fr/createTraining.json";
import fr_playCreator from "./locales/fr/playCreator.json";
import fr_attendance from "./locales/fr/attendance.json";
import fr_auth from "./locales/fr/auth.json";
import fr_playdetails from "./locales/fr/playDetails.json";
import fr_livestats from "./locales/fr/livestats.json";
import fr_tournament from "./locales/fr/tournament.json";
import fr_tournamentAdmin from "./locales/fr/tournamentAdmin.json";
import fr_success from "./locales/fr/success.json";
import fr_createTournament from "./locales/fr/createTournament.json";
import fr_planTraining from "./locales/fr/planTraining.json";
import fr_cancel from "./locales/fr/cancel.json";
import fr_shooting from "./locales/fr/shooting.json";
import fr_shootingtotals from "./locales/fr/shootingtotals.json";
import fr_teams from "./locales/fr/teams.json";
import fr_acceptinvite from "./locales/fr/acceptinvite.json"
import fr_archivedteams from "./locales/fr/archivedteams.json"
import fr_loginclub from "./locales/fr/loginclub.json"
import fr_notifications from "./locales/fr/notifications.json"
import fr_onboarding from "./locales/fr/onboarding.json"
import fr_rotations from "./locales/fr/rotations.json"

// EN
import en_common from "./locales/en/common.json";
import en_dashboard from "./locales/en/dashboard.json";
import en_myteam from "./locales/en/myteam.json";
import en_editteam from "./locales/en/editteam.json";
import en_addplayer from "./locales/en/addplayer.json";
import en_teamstats from "./locales/en/teamstats.json";
import en_seasonstats from "./locales/en/seasonstats.json";
import en_createteam from "./locales/en/createteam.json";
import en_legal from "./locales/en/legal.json";
import en_terms from "./locales/en/terms.json";
import en_footer from "./locales/en/footer.json";
import en_home from "./locales/en/home.json";
import en_contact from "./locales/en/contact.json";
import en_glossary from "./locales/en/glossary.json";
import en_features from "./locales/en/features.json";
import en_pricing from "./locales/en/pricing.json";
import en_profile from "./locales/en/profile.json";
import en_editprofile from "./locales/en/editprofile.json";
import en_playerpage from "./locales/en/playerpage.json";
import en_allmatches from "./locales/en/allmatches.json";
import en_matchdetails from "./locales/en/matchdetails.json";
import en_news from "./locales/en/news.json";
import en_login from "./locales/en/login.json";
import en_upgrade from "./locales/en/upgrade.json";
import en_signup from "./locales/en/signup.json";
import en_matchstats from "./locales/en/matchstats.json";
import en_editstats from "./locales/en/editstats.json";
import en_editmatch from "./locales/en/editmatch.json";
import en_trainingdetails from "./locales/en/trainingdetails.json"; 
import en_allplays from "./locales/en/allplays.json";
import en_alltrainings from "./locales/en/alltrainings.json";
import en_creatematch from "./locales/en/creatematch.json";
import en_resetpassword from "./locales/en/resetpassword.json";
import en_editplayer from "./locales/en/editplayer.json";
import en_plandetails from "./locales/en/plandetails.json";
import en_playbooks from "./locales/en/playbooks.json";
import en_playbookdetails from "./locales/en/playbookdetails.json";
import en_playbookeditor from "./locales/en/playbookeditor.json";
import en_resources from "./locales/en/resources.json";
import en_profilepublic from "./locales/en/profilepublic.json";
import en_teamplayers from "./locales/en/teamplayers.json";
import en_communityplays from "./locales/en/communityplays.json";
import en_editplay from "./locales/en/editplay.json";
import en_sharedplay from "./locales/en/sharedplay.json";
import en_createTraining from "./locales/en/createTraining.json";
import en_playCreator from "./locales/en/playCreator.json";
import en_attendance from "./locales/en/attendance.json";
import en_auth from "./locales/en/auth.json";
import en_playdetails from "./locales/en/playDetails.json";
import en_livestats from "./locales/en/livestats.json";
import en_tournament from "./locales/en/tournament.json";
import en_tournamentAdmin from "./locales/en/tournamentAdmin.json";
import en_success from "./locales/en/success.json";
import en_createTournament from "./locales/en/createTournament.json";
import en_planTraining from "./locales/en/planTraining.json";
import en_cancel from "./locales/en/cancel.json";
import en_shooting from "./locales/en/shooting.json";
import en_shootingtotals from "./locales/en/shootingtotals.json";
import en_teams from "./locales/en/teams.json";
import en_acceptinvite from "./locales/en/acceptinvite.json"
import en_archivedteams from "./locales/en/archivedteams.json"
import en_loginclub from "./locales/en/loginclub.json"
import en_notifications from "./locales/en/notifications.json"
import en_onboarding from "./locales/en/onboarding.json"
import en_rotations from "./locales/en/rotations.json"


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { common: fr_common, dashboard: fr_dashboard, myteam: fr_myteam, editteam: fr_editteam, addplayer: fr_addplayer, teamstats: fr_teamstats, seasonstats: fr_seasonstats, 
        createteam: fr_createteam, legal: fr_legal, terms: fr_terms, footer: fr_footer, home: fr_home, contact: fr_contact, glossary: fr_glossary, features: fr_features, pricing: fr_pricing,
        profile: fr_profile, editprofile: fr_editprofile, playerpage: fr_playerpage, allmatches: fr_allmatches, matchdetails: fr_matchdetails, news: fr_news, login: fr_login, upgrade: fr_upgrade,
        signup: fr_signup, matchstats: fr_matchstats, editstats: fr_editstats, editmatch: fr_editmatch, trainingdetails: fr_trainingdetails, allplays: fr_allplays, alltrainings: fr_alltrainings,
        creatematch: fr_creatematch, resetpassword: fr_resetpassword, editplayer: fr_editplayer, plandetails: fr_plandetails, playbooks: fr_playbooks, playbookdetails: fr_playbookdetails, playbookeditor: fr_playbookeditor,
        resources: fr_resources, profilepublic: fr_profilepublic, teamplayers: fr_teamplayers, communityplays: fr_communityplays, editplay: fr_editplay, sharedplay: fr_sharedplay, createTraining: fr_createTraining,
        playCreator: fr_playCreator, attendance: fr_attendance, auth: fr_auth, playDetails: fr_playdetails, livestats: fr_livestats, tournament: fr_tournament, tournamentAdmin: fr_tournamentAdmin,
        success: fr_success, createTournament: fr_createTournament, planTraining: fr_planTraining, cancel: fr_cancel, shooting: fr_shooting, shootingtotals: fr_shootingtotals, teams: fr_teams, acceptinvite: fr_acceptinvite, archivedteams: fr_archivedteams, loginclub: fr_loginclub, notifications: fr_notifications, onboarding: fr_onboarding, rotations: fr_rotations
       },
      en: { common: en_common, dashboard: en_dashboard, myteam: en_myteam, editteam: en_editteam, addplayer: en_addplayer, teamstats: en_teamstats, seasonstats: en_seasonstats,
        createteam: en_createteam, legal: en_legal, terms: en_terms, footer: en_footer, home: en_home, contact: en_contact, glossary: en_glossary, features: en_features, pricing: en_pricing,
        profile: en_profile, editprofile: en_editprofile, playerpage: en_playerpage, allmatches: en_allmatches, matchdetails: en_matchdetails, news: en_news, login: en_login,  upgrade: en_upgrade,
        signup: en_signup, matchstats: en_matchstats, editstats: en_editstats, editmatch: en_editmatch, trainingdetails: en_trainingdetails, allplays: en_allplays, alltrainings: en_alltrainings,
        creatematch: en_creatematch, resetpassword: en_resetpassword, editplayer: en_editplayer, plandetails: en_plandetails, playbooks: en_playbooks, playbookdetails: en_playbookdetails, playbookeditor: en_playbookeditor,
        resources: en_resources, profilepublic: en_profilepublic, teamplayers: en_teamplayers, communityplays: en_communityplays, editplay: en_editplay, sharedplay: en_sharedplay, createTraining: en_createTraining,
        playCreator: en_playCreator, attendance: en_attendance, auth: en_auth, playDetails: en_playdetails, livestats: en_livestats, tournament: en_tournament, tournamentAdmin: en_tournamentAdmin,
        success: en_success, createTournament: en_createTournament, planTraining: en_planTraining, cancel: en_cancel, shooting: en_shooting, shootingtotals: en_shootingtotals, teams: en_teams, acceptinvite: en_acceptinvite, archivedteams: en_archivedteams, loginclub: en_loginclub, notifications: en_notifications, onboarding: en_onboarding, rotations: en_rotations
       },
    },
    ns: ["common", "dashboard", "myteam", "editteam", "addplayer", "teamstats", "seasonstats", "createteam", "legal", "terms", "footer", "home", "contact", "glossary", "features", "pricing",
        "profile", "editprofile", "playerpage", "allmatches", "matchdetails", "news", "login", "upgrade","signup", "matchstats", "editstats", "editmatch", "trainingdetails", "allplays", "alltrainings",
        "creatematch", "resetpassword", "editplayer", "plandetails", "playbooks", "playbookdetails", "playbookeditor", "resources", "profilepublic", "teamplayers", "communityplays", "editplay",
        "sharedplay", "createTraining", "playCreator", "attendance", "auth", "playDetails", "livestats", "tournament", "tournamentAdmin", "success", "createTournament", "planTraining", "cancel", "shooting", "shootingtotals",
        "teams", "acceptinvite", "archivedteams", "loginclub", "notifications", "onboarding", "rotations"
    ],
    defaultNS: "common",
    fallbackLng: "fr",
    supportedLngs: ["fr", "en"],
    interpolation: { escapeValue: false },
    detection: { order: ["localStorage", "querystring", "htmlTag", "navigator"], caches: ["localStorage"] },
    returnNull: false,
    returnEmptyString: false,
    debug: false,
  });

i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") document.documentElement.setAttribute("lang", lng);
});

// utile en dev pour repérer une clé manquante
i18n.on("missingKey", (_lngs, ns, key) => {
  if (process.env.NODE_ENV !== "production") console.warn(`[i18n missing] ${ns}:${key}`);
});

// Clé posée par LanguageToggle quand l'utilisateur choisit une langue à la main.
// Tant qu'elle est absente, on peut resynchroniser sur la langue de l'appareil.
export const LANG_USER_SET_KEY = "swishdata_lang_user_set";

// Détection langue natif (iOS/Android) : `navigator.language` n'est pas fiable
// dans la WebView Capacitor pour refléter Réglages > Langue de l'appareil.
// On interroge donc l'API native via @capacitor/device, uniquement si
// l'utilisateur n'a jamais choisi explicitement sa langue dans l'app.
(async () => {
  try {
    if (!Capacitor.isNativePlatform()) return;
    if (typeof window !== "undefined" && window.localStorage.getItem(LANG_USER_SET_KEY)) return;

    const { value } = await Device.getLanguageCode(); // ex: "fr", "en", "de"...
    const detected = value?.toLowerCase().startsWith("fr") ? "fr" : "en";

    if (i18n.language !== detected) {
      await i18n.changeLanguage(detected);
    }
  } catch {
    // silencieux : on reste sur la langue déjà résolue par le detector web
  }
})();

export default i18n;
